import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { OverviewTab } from '@/features/analytics/components/OverviewTab';
import { PastWebinarsTab } from '@/features/analytics/components/PastWebinarsTab';
import { AnalyticsComparator } from '@/features/analytics/pages/AnalyticsComparator';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Analytics() {
  const { t } = useTranslation('analytics');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'overview';
  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };
  return (
    <div className="flex flex-col gap-8 w-full max-w-full overflow-hidden">
      <h1 className="text-[32px] font-semibold tracking-tight text-dark px-2 font-poppins">
        {t('page.title')}
      </h1>

      <Tabs className="w-full" value={activeTab} onValueChange={handleTabChange}>
        <div className="w-full border-b border-neutral-100 mb-8 overflow-x-auto no-scrollbar">
          <TabsList className="justify-start h-auto p-0 bg-transparent rounded-none flex min-w-max w-full">
            <TabsTrigger
              value="overview"
              className="px-8 cursor-pointer py-3 text-base font-medium rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:text-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none whitespace-nowrap transition-all"
            >
              {t('page.tabs.overview')}
            </TabsTrigger>
            <TabsTrigger
              value="past-webinars"
              className="px-8 cursor-pointer py-3 text-base font-medium rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:text-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none whitespace-nowrap transition-all"
            >
              {t('page.tabs.pastWebinars')}
            </TabsTrigger>
            <TabsTrigger
              value="comparator"
              className="px-8 cursor-pointer py-3 text-base font-medium rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:text-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none whitespace-nowrap transition-all"
            >
              {t('page.tabs.comparator')}
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="overview" className="mt-0 outline-none">
          <OverviewTab />
        </TabsContent>

        <TabsContent value="past-webinars" className="mt-0 outline-none">
          <PastWebinarsTab />
        </TabsContent>

        <TabsContent value="comparator" className="mt-0 outline-none">
          <AnalyticsComparator />
        </TabsContent>
      </Tabs>
    </div>
  );
}
